import { useBalanceStore } from '@/entities/balance';

export const useShowViewPlans = () => {
  const { hasFreeSubscription, hasTrialPlan, isBalanceLoaded } = useBalanceStore();

  return isBalanceLoaded && (hasFreeSubscription || hasTrialPlan);
};
